module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "presence-for-users text-dark"
  }, [_c('div', {
    staticClass: "d-table-layout"
  }, [_c('div', {
    staticClass: "d-table-layout__col"
  }, [_c('div', {
    staticClass: "d-table-layout__header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_presence_to_many_user']))]), _vm._v(" "), _c('div', {
    staticClass: "d-table-layout__header__right"
  }, [_c('p', [_vm._v(_vm._s(_vm.selectedIdsLength) + " " + _vm._s(_vm.i18n[_vm.locale]['of']) + " " + _vm._s(_vm.usersFiltered.length))]), _vm._v(" "), (_vm.selectedIdsLength < 1) ? _c('div', {
    staticClass: "hint--bottom-left",
    attrs: {
      "aria-label": _vm.$t('vue2.tagging.select_persons_first')
    }
  }, [_c('button', {
    staticClass: "up__button no-print bttn bttn--disabled"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.presence.work_hours')) + "\n              "), _c('span', {
    staticClass: "icon-arrow-down5"
  })])]) : _c('PresenceUser', {
    attrs: {
      "firstDayOfWeek": _vm.firstDayOfWeek
    },
    on: {
      "save": _vm.savePresence
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-table-layout__header"
  }, [_c('div', [(_vm.selectedIdsLength < 1) ? _c('p', {
    staticClass: "text-link",
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.tagging.select_all')))]) : _c('p', {
    staticClass: "text-link",
    on: {
      "click": _vm.unSelectAll
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))])]), _vm._v(" "), _c('TaggingFilter', {
    attrs: {
      "users": _vm.usersWithProps,
      "showHowMany": false,
      "tags": _vm.tags,
      "selectedTags": _vm.selectedTags,
      "schoolid": _vm.schoolId
    },
    on: {
      "set": _vm.setTag,
      "remove": _vm.removeTag
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-table-layout__body"
  }, [(_vm.isLoadingSchoolCalenders) ? _c('Loader', {
    attrs: {
      "bgColor": "#fff"
    }
  }) : [(_vm.usersWithProps.length < 1) ? _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_users_created']))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "presence__user-list"
  }, _vm._l((_vm.usersWithProps), function(user) {
    return _c('li', {
      key: user.id,
      class: {
        'user--selected': user.v_isSelected
      },
      on: {
        "click": function($event) {
          return _vm.toggleUser(user.id)
        }
      }
    }, [_c('div', {
      staticClass: "d-checkbox",
      class: {
        'd-checkbox--active': user.v_isSelected
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])])
  }), 0)]], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33d00cc7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Presence/PresenceForUsers.vue
// module id = 1847
// module chunks = 1